import type { CSSProperties } from 'react';
import { tokens } from '@fluentui/react-components';
import { themeVar } from '../theme/themeConfig';

export const cardSurfaceStyle: CSSProperties = {
  backgroundColor: tokens.colorNeutralBackground1,
  borderRadius: themeVar('card', 'borderRadius', '8px'),
  border: themeVar('card', 'border', 'none'),
  boxShadow: themeVar('card', 'shadow', '0 1px 4px rgba(0,0,0,0.08)'),
  padding: '20px',
  boxSizing: 'border-box',
};
